module.exports = __webpack_public_path__ + "static/media/Captain Marvel 3.925cce53.jpg";